export default __webpack_public_path__ + "static/media/TwitterSVG.1c4b9f99.svg";